module.exports = __webpack_public_path__ + "img/ic_plus.08e378f1.svg";